// Function that splits insurance names with a soft hyphen, e.g. Ökutækjatrygging -> Ökutækja-trygging
// If the name doesn't contain trygging, the name is returned as is
export const splitInsuranceNameWithHyphen = (name: string) =>
  name.indexOf('trygging') > -1 ? name.split('trygging')[0] + '\u{00AD}trygging' : name
